module.exports = __webpack_public_path__ + "static/media/BotImg.2ae574ce.png";